import * as Preact from "preact"
import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import World from "@frog/source/models/World.js"

import player from "@frog/source/data/games/pirates/player.js"
const PLAYER_CHARACTER = "swashbuckler"

export default {
    "slug": "wild",
    "hasPreparePhase": false,

    "stage": {
        "image": require("./wild.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "configuration": {
            "darkness": "none",
        },
        "text": function(stage) {
            if(stage.currentEncounterKey == "4") {
                if(stage.flags["tutorial:hasDug"] != true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">Dig up the treasure by attacking the x mark on the ground.</div>
                        </div>
                    )
                }
                if(stage.flags["tutorial:hasDug"] == true) {
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">We can see the top of the treasure chest! But we'll need to dig it one more time.</div>
                        </div>
                    )
                }
            }

            if(stage.flags["tutorial:hasHealed"] != true) {
                if(stage.flags["tutorial:weakUnitKey"] != undefined) {
                    const unitKey = stage.flags["tutorial:weakUnitKey"]
                    return (
                        <div class="TutorialPrompt" position="topright">
                            <div class="Text">{stage.units[unitKey].name} is hurt, but Eleanor can heal them!</div>
                        </div>
                    )
                }
            } else {
                return (
                    <div class="TutorialPrompt" position="topright">
                        <div class="Text">When healing an ally, Eleanor also heals herself!</div>
                    </div>
                )
            }
        },
        "conditions": [
            {
                // Chapter start
                "type": "turn:0:start",
                "title": "Chapter start",
                "events": [
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.PlayAudio("Pirate:Music:Opening"),
                    PlotSteps.PlayAudio("Pirate:Ambience:Beach"),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawn"}),
                    PlotSteps.ChapterStart([
                        "Chapter 2",
                        "The Buried Treasure",
                        "In Which",
                        "Eleanor fights the undead",
                        "and digs up a treasure chest"
                    ]),
                    PlotSteps.PlayAudio("Pirate:Music:TreasureIsland"),
                    // Music starts
                    "SWASHBUCKLER: This is it! Just as the map said it would be.",
                    "SWINDLER: And with it, the treasure?",
                    "SWASHBUCKLER: If the legends are true, the golden key should be buried here~",
                    "MERCENARY: ...Look alive, the dead are here.",
                ]
            },
            {
                // Next encounter starts
                "type": "condition",
                "title": "Next Encounter",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "1"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"encounterKey": "1", "affiliation": "good"})
                },
                "events": [
                    // Heroes move to the next encounter
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "2"}),
                    "SWINDLER: ...",
                    GetWeakestUnit(),
                ]
            },
            {
                "type": "turn:every-even:start",
                "events": [
                    GetWeakestUnit(),
                ]
            },
            // {
            //     // Reinforcements appear
            //     "type": "condition",
            //     "title": "Reinforcements appear!",
            //     "condition": (stage) => {
            //         return stage.currentEncounterKey == "2"
            //             && stage.turn.number == 2
            //             && stage.turn.phase == "start"
            //     },
            //     "events": [
            //     ]
            // },
            {
                // Next encounter starts
                "type": "condition",
                "title": "Next Encounter",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "2"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"encounterKey": "2", "affiliation": "good"})
                },
                "events": [
                    // Heroes move to the next encounter
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "3"}),
                ]
            },
            // {
            //     // Castaway appears
            //     "type": "condition",
            //     "title": "A castaway stumbles in",
            //     "condition": (stage) => {
            //         return stage.currentEncounterKey == "3"
            //             && stage.turn.number == 2
            //             && stage.turn.phase == "start"
            //     },
            //     "events": [
            //     ]
            // },
            {
                // Striking Gold
                "type": "condition",
                "title": "Treasure at last!",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "3"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"encounterKey": "3", "affiliation": "good"})
                },
                "events": [
                    // Heroes move to the final encounter
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "4"}),
                    "SWASHBUCKLER: “Walk five paces south by southwest.”",
                    "SWINDLER: “And x marks the spot.” We did it!!",
                    "SWINDLER: Grab a shovel, and get digging!!",
                ]
            },
            {
                "type": "recruiting",
                "canBeTriggered": (stage, performer, target) => {
                    return target.jobKey?.includes("chest")
                        && stage.flags["Treasure"] != true
                },
                "events": [
                    "SWASHBUCKLER: Phew! The treasure cache of <old legend captain>. And with it, the golden key!",
                    "MERCENARY: That’ll have to wait - more undead are heading this way",
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bad", "protounit": {"jobKey": "pirates/hammerknight", "maxhealth": 30, "imageKey": "skeleton", "affiliation": "bad"}}),
                    Step.flag("Treasure", true),
                ]
            },
            {
                "type": "recruiting",
                "canBeTriggered": (stage, performer, target) => {
                    return target.jobKey?.includes("chest")
                        && stage.flags["Treasure"] == true
                        && performer.key == "mercenary"
                },
                "events": [
                    "MERCENARY: With this much gold, Esther would never go hungry.",
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bad", "protounit": {"jobKey": "pirates/hammerknight", "maxhealth": 30, "imageKey": "skeleton", "affiliation": "bad"}}),
                ]
            },
            {
                "type": "recruiting",
                "canBeTriggered": (stage, performer, target) => {
                    return target.jobKey?.includes("chest")
                        && stage.flags["Treasure"] == true
                        && performer.key == "swashbuckler"
                },
                "events": [
                    "SWASHBUCKLER: The stories they will tell of this day!",
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bad", "protounit": {"jobKey": "pirates/hammerknight", "maxhealth": 30, "imageKey": "skeleton", "affiliation": "bad"}}),
                ]
            },
            {
                "type": "recruiting",
                "canBeTriggered": (stage, performer, target) => {
                    return target.jobKey?.includes("chest")
                        && stage.flags["Treasure"] == true
                        && performer.key == "swindler"
                },
                "events": [
                    "SWINDLER: This is better than I could've imagined.",
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bad", "protounit": {"jobKey": "pirates/hammerknight", "maxhealth": 30, "imageKey": "skeleton", "affiliation": "bad"}}),
                ]
            },
            {
                // This be MUTINY
                "type": "condition",
                "title": "What's this? MUTINY??",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.flags["Mutiny"] != true
                        && stage.flags["Treasure"] == true
                        && stage.units[PLAYER_CHARACTER].isDead == false
                        && stage.units["treasureA"].health == stage.units["treasureA"].maxhealth
                        && stage.units["treasureB"].health == stage.units["treasureB"].maxhealth
                        && stage.units["treasureC"].health == stage.units["treasureC"].maxhealth
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "bad"}) == 0
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "good"}) > 1
                },
                "events": [
                    PlotSteps.KillAudio({"label": "music"}),
                    "SWASHBUCKLER: Back to Davy Jones with you! Tell him you sent you, <titles> <titles>",
                    ": ...",
                    ": .....",
                    ": .......",
                    // The rogues start backstabbing!
                    PlotSteps.PlayAudio("Pirate:Music:Mutiny"),

                    ifUnitIsAliveAndAllied("swindler", "good", [
                        Step.deltastage({"camera": {"unitKey": "swindler"}}),
                        PlotSteps.Wait(300),
                        "SWINDLER: That's as far as you go, Ellie.",

                        Step.deltastage({"unit": {"key": "swindler", "affiliation": "blue"}}),
                        "SYLVESTER HAS MUTINIED.",

                        Step.deltastage({"camera": {"unitKey": null}}),
                    ]),

                    ifUnitIsAliveAndAllied("mercenary", "good", [
                        Step.deltastage({"camera": {"unitKey": "mercenary"}}),
                        PlotSteps.Wait(300),
                        "MERCENARY: Look at all this treasure. All for me.",

                        Step.deltastage({"unit": {"key": "mercenary", "affiliation": "orange"}}),
                        "JOE BOOTS HAS MUTINIED",

                        Step.deltastage({"camera": {"unitKey": null}}),
                    ]),

                    "SWASHBUCKLER: Draw your blades then, you cowards!!",

                    Step.flag("Mutiny", true),
                    Step.deltastage({"turn": {"number": 0, "phase": "start", "affiliation": "good"}}),
                    {"type": "restart"},
                ]
            },
            {
                "type": "condition",
                "title": "Yours for the taking",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.flags["Mutiny"] == true
                        && stage.flags["Treasure"] == true
                        && stage.units[PLAYER_CHARACTER].isDead == false
                        && stage.units["treasureA"].health == stage.units["treasureA"].maxhealth
                        && stage.units["treasureB"].health == stage.units["treasureB"].maxhealth
                        && stage.units["treasureC"].health == stage.units["treasureC"].maxhealth
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "bad"}) == 0
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "blue"}) == 0
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "orange"}) == 0
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "green"}) == 0
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": "good"}) == 1
                },
                "events": [
                    PlotSteps.PlayStinger("Pirate:Stinger:Victory"),
                    "SWASHBUCKLER: Ha ha! Fall before me you dogs! No booty for backstabbers!",
                    "SWASHBUCKLER: ...",
                    "SWASHBUCKLER: Now how do I get this all back to port?",
                    PlotSteps.ChapterSuccessClassic(),
                    PlotSteps.ReportSuccessAnalytics(),
                    PlotSteps.PlayAudio("Pirate:Music:MorningTide"),
                    {"func": () => Navigation.go("/credits")},
                    // PlotSteps.UpdateTraitorousPartyScript(),
                    // PlotSteps.SaveGame("tavern"),
                    // {"func": () => Navigation.go("/games/pirates/chapters/tavern")},
                ]
            },
            {
                "type": "condition",
                "title": "Yours for the taking",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.flags["Treasure"] == true
                        && stage.flags["Mutiny"] != true
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"encounterKey": "4", "affiliation": "good"})
                        && stage.units[PLAYER_CHARACTER].isDead == false
                        && getUnitCount(stage, {"encounterKey": "4"}) == 1
                },
                "events": [
                    PlotSteps.PlayStinger("Pirate:Stinger:Victory"),
                    "SWASHBUCKLER: Back to Davy Jones with you! Tell him you sent you, <titles> <titles>",
                    "SWASHBUCKLER: ...",
                    "SWASHBUCKLER: Now how do I get this all back to port?",
                    PlotSteps.ChapterSuccessClassic(),
                    PlotSteps.ReportSuccessAnalytics(),
                    PlotSteps.UpdateTraitorousPartyScript(),
                    // PlotSteps.UpdateTraitorousPartyScript(),
                    // PlotSteps.SaveGame({"nextChapterSlug": "tavern"}),
                    // {"func": () => Navigation.go("/games/pirates/chapters/tavern")},
                ]
            },
            {
                "type": "condition",
                "title": "Loss",
                "condition": function(stage) {
                    return stage.units[PLAYER_CHARACTER].isDead == true
                },
                "events": [
                    // Failure banner spreads on the screen
                    PlotSteps.ChapterFailure(),
                    // Chapter restarts
                    PlotSteps.ReportFailureAnalytics(),
                    {"func": () => App.game.chapter.restart()},
                ]
            },
            {
                "type": "death",
                "unitKey": "swindler",
                "condition": (stage) => stage.flags["Mutiny"] == true,
                "events": [
                    "SWINDLER: Bah, so close.",
                    "SWINDLER: No hard feelings?",
                ]
            },
            {
                "type": "death",
                "unitKey": "mercenary",
                "condition": (stage) => stage.flags["Mutiny"] == true,
                "events": [
                    "MERCENARY: Eh, I knew it was a gamble.",
                    "MERCENARY: I shouldn’t have bluffed.",
                ]
            },
            {
                "type": "before attacking",
                "canBeTriggered": (stage, performer, target) => {
                    return stage.flags["Mutiny"] == true
                        && stage.flags["hasEleanorTalkedWithBoots"] != true
                        && ((performer.key == "swashbuckler" && target.key == "mercenary")
                        || (performer.key == "mercenary" && target.key == "swashbuckler"))
                },
                "events": [
                    "SWASHBUCKLER: I had suspected this of Sylvester, but you?",
                    "MERCENARY: The seas are harsh for us all.",
                    Step.flag("hasEleanorTalkedWithBoots", true),
                    PlotSteps.MarkAchievement("ACH_THIS_BE_MUTINY"),
                ]
            },
            {
                "type": "before attacking",
                "canBeTriggered": (stage, performer, target) => {
                    return stage.flags["Mutiny"] == true
                        && stage.flags["hasEleanorTalkedWithSylvester"] != true
                        && ((performer.key == "swashbuckler" && target.key == "swindler")
                        || (performer.key == "swindler" && target.key == "swashbuckler"))
                },
                "events": [
                    "SWINDLER: It is only business, you have to understand.",
                    Step.flag("hasEleanorTalkedWithSylvester", true),
                    PlotSteps.MarkAchievement("ACH_THIS_BE_MUTINY"),
                ]
            },
            {
                "type": "turn:every:start",
                "events": [
                    PlotSteps.ReportStartTurnAnalytics(),
                ]
            },
            {
                "type": "turn:every:end",
                "events": [
                    PlotSteps.ReportEndTurnAnalytics(),
                ]
            },
        ]
    },
}

function getUnitCount(stage, {affiliation}) {
    return Object.values(stage.units).filter((unit) => {
        return (unit.affiliation == affiliation || affiliation == undefined)
            && Zone.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position) == true
            && unit.isDead != true
            && unit.type != "zone"
    }).length
}

function ifUnitIsAliveAndAllied(unitKey, alliedAffiliation, events) {
    return (stage) => {
        if(stage.units[unitKey] != undefined
        && stage.units[unitKey].isDead != true
        && stage.units[unitKey].hasBeenRemoved != true
        && stage.units[unitKey].affiliation == alliedAffiliation) {
            return events
        }
    }
}

function GetWeakestUnit() {
    return (stage) => {
        let weakestUnit = undefined
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == stage.player.affiliation
            && unit.key != "swashbuckler"
            && unit.health < unit.maxhealth) {
                if(weakestUnit == undefined) {
                    weakestUnit = unit
                } else if((unit.health / unit.maxhealth) < (weakestUnit.health / weakestUnit.maxhealth)) {
                    weakestUnit = unit
                }
            }
        })

        if(weakestUnit != undefined) {
            return Step.flag("tutorial:weakUnitKey", weakestUnit.key)
        }
    }
}
